<template>
    <vs-popup class="add-new-incoterms" id="popup" :title="isCreateMode ? 'CREATE AN INDIRECT CHANNEL PARTNER' : 'UPDATE AN INDIRECT CHANNEL PARTNER'"
        @close="open = false" :active.sync="open" :buttons-hidden="true">
        <vx-card no-shadow>
            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                <form id="create-marketing-lead-popup" @submit.prevent="handleSubmit(onClickCreateSite)" autocomplete="off">

                    <div class="mb-3 vx-row">
                        <div class="w-full vx-col md:w-1/2 md:mb-0">
                            <ValidationProvider vid="first_name" name="first_name" rules="required" v-slot="{ errors }">
                                <small class="label">First Name</small>
                                <vs-input v-model="form.first_name" name="first_name" class="w-full" label=""
                                    :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                    val-icon-pack="feather" />
                            </ValidationProvider>
                        </div>
                        <div class="w-full vx-col md:w-1/2 md:mb-0">
                            <ValidationProvider vid="last_name" name="last_name" rules="required" v-slot="{ errors }">
                                <small class="label">Last Name</small>
                                <vs-input v-model="form.last_name" name="last_name" class="w-full" label=""
                                    :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                    val-icon-pack="feather" />
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="mb-3 vx-row">
                        <div class="w-full vx-col md:w-1/2 md:mb-0">
                            <ValidationProvider vid="email_address" name="email_address" rules="required|email"
                                v-slot="{ errors }">
                                <small class="label">Email Address</small>
                                <vs-input v-model="form.email" name="email_address" class="w-full" label=""
                                    :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                    val-icon-pack="feather" />
                            </ValidationProvider>
                        </div>
                        <div class="w-full vx-col md:w-1/2 md:mb-0">
                            <ValidationProvider vid="company_name" name="company_name" rules="required" v-slot="{ errors }">
                                <small class="label">Company Name</small>
                                <vs-input v-model="form.company_name" name="company_name" class="w-full" label=""
                                    :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                    val-icon-pack="feather" />
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="vx-row mb-3">
                        <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider vid="industry_sector" name="industry_sector" rules="" v-slot="{ errors }">
                                <small class="label">Industry Sector</small>
                                <v-select multiple v-on:input="onChangeIndustrySector" :clearable="false"
                                    :closeOnSelect="false" name="industry_sector" placeholder="" label="name"
                                    v-model="form.sector" :reduce="option => option.id" :options="industrySectors"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'">
                                    <template v-slot:option="option">
                                        <span>{{ option.name }} </span>
                                    </template>
                                </v-select>

                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider vid="industry_sub_sector" name="industry_sub_sector" rules=""
                                v-slot="{ errors }">
                                <small class="label">Industry Sub Sector</small>
                                <v-select multiple :clearable="false" :closeOnSelect="false" name="industry_sub_sector"
                                    placeholder="" label="name" v-model="form.sub_sector" :reduce="option => option.id"
                                    :options="industrySubSectors" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                                    <template v-slot:option="option">
                                        <span>{{ option.name }} </span>
                                    </template>
                                    <template #no-options="{ search, searching, loading }">
                                        Please select Industry Sector first!
                                    </template>
                                </v-select>
                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="vx-row mb-3">
                        <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider vid="source" name="source" rules="" v-slot="{ errors }">
                                <small class="label">Source</small>
                                <v-select multiple v-on:input="onChangeCustomerSource" :clearable="false"
                                    :closeOnSelect="false" name="industry_sector" placeholder="" label="name"
                                    v-model="form.source" :reduce="option => option.id" :options="customerSources"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'">
                                    <template v-slot:option="option">
                                        <span>{{ option.name }} </span>
                                    </template>
                                </v-select>

                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider vid="sub_source" name="sub_source" rules="" v-slot="{ errors }">
                                <small class="label">Sub Source</small>
                                <v-select multiple :clearable="false" :closeOnSelect="false" name="sub_source"
                                    placeholder="" label="name" v-model="form.sub_source" :reduce="option => option.id"
                                    :options="customerSubSources" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                                    <template v-slot:option="option">
                                        <span>{{ option.name }} </span>
                                    </template>
                                    <template #no-options="{ search, searching, loading }">
                                        Please select Industry Sector first!
                                    </template>
                                </v-select>
                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="vx-row mb-3">
                        <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider vid="account_handler_id" name="account_handler_id" rules=""
                                v-slot="{ errors }">
                                <small class="label">Account Handler</small>
                                <v-select :clearable="false" name="account_handler_id" placeholder="" label="name"
                                    :reduce="option => option.value" v-model="form.account_handler_id" :options="staffs"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider vid="country" name="country" rules="" v-slot="{ errors }">
                                <small class="label">Country</small>
                                <v-select :clearable="false" name="country" placeholder="" label="name"
                                    :reduce="option => option.name" v-model="form.country" :options="countries"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="mb-3 vx-row">
                        <div class="w-full vx-col">
                            <ValidationProvider vid="system_comment" name="system_comment" rules="" v-slot="{ errors }">
                                <small class="label">Comments</small>
                                <vs-textarea class="mb-0" v-model="form.comment" height="150px" />
                                <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>

                    <!-- Save & Reset Button -->
                    <div class="flex flex-wrap items-center justify-end mt-8">
                        <vs-button button="submit" class="mt-2 ml-auto">Save
                            Changes</vs-button>
                        <vs-button @click="form = {}" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
                    </div>
                </form>
            </ValidationObserver>
        </vx-card>
    </vs-popup>
</template>
  
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const CrmRepository = RepositoryFactory.get('crm');
const CustomerRepository = RepositoryFactory.get('customer');
const CustomerSourceRepository = RepositoryFactory.get('customer_source')

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import { mapActions, mapGetters } from 'vuex';

function initialState() {
    return {
        open: false,
        id: '',
        form: {},
        isCreateMode: true,
        industrySectors: [],
        industrySubSectors: [],
        customerSources: [],
        customerSubSources: []
    }
}

export default {
    name: 'CreateIndirectChannelPartnerPopUp',
    data() {
        return initialState()
    },
    methods: {
        ...mapActions(['fetchCountries', 'fetchStaffs']),
        async openPopup(id) {
            try {
                await Object.assign(this.$data, initialState());
                await this.$refs.form.reset();
                this.open = true;
                await this.loadIndustrySectors();
                await this.loadCustomerSources();
                await this.fetchCountries()
                await this.fetchStaffs()
                if (!!id) {
                    this.id = id
                    this.isCreateMode = false
                    await this.fetchIncotermDetails()
                } else {
                    this.isCreateMode = true
                }
            } catch (error) {

            }
        },
        async fetchIncotermDetails() {
            await this.$vs.loading({
                container: '#create-marketing-lead-popup',
                scale: 0.45
            })
            try {
                const { data } = (await CrmRepository.getIndirectChannelDetails(this.id)).data
                this.form = data
                if (this.form.sub_sector.length !== 0) {
                    const { data } = (await CustomerRepository.getIndustrySubSectors({ ids: this.form.sector })).data
                    this.industrySubSectors = data
                }
                if (this.form.sub_source.length !== 0) {
                    const { data } = (await CustomerSourceRepository.getCustomerSubSources({ ids: this.form.source })).data
                    this.customerSubSources = data
                }
            } catch (e) {
                this.convertAndNotifyError(e)
            }
            this.$vs.loading.close('#create-marketing-lead-popup > .con-vs-loading')
        },
        async loadIndustrySectors() {
            const { data } = (await CustomerRepository.getIndustrySectors()).data
            this.industrySectors = data
        },
        async onChangeIndustrySector(ids) {
            await this.$vs.loading();
            try {
                this.form.sub_sector = []
                const { data } = (await CustomerRepository.getIndustrySubSectors({ ids: ids })).data
                this.industrySubSectors = data
            } catch (e) {
                this.convertAndNotifyError(e)
            }
            await this.$vs.loading.close()
        },
        async loadCustomerSources() {
            const { data } = (await CustomerSourceRepository.getListOfCustomerSource()).data
            this.customerSources = data
        },
        async onChangeCustomerSource(ids) {
            await this.$vs.loading();
            try {
                this.form.sub_source = []
                const { data } = (await CustomerSourceRepository.getCustomerSubSources({ ids: ids })).data
                this.customerSubSources = data
            } catch (e) {
                this.convertAndNotifyError(e)
            }
            await this.$vs.loading.close()
        },
        async onClickCreateSite() {
            const vue = this;
            await this.$vs.loading({
                container: '#create-marketing-lead-popup',
                scale: 0.45
            })
            try {
                if (this.isCreateMode) {
                    let payload = {}
                    Object.assign(payload, this.form)
                    await CrmRepository.createIndirectChannelPartner(payload);
                    this.showSuccessMessage('Lead created successfully');
                } else {
                    let payload = {}
                    Object.assign(payload, this.form)
                    await CrmRepository.updateIndirectChannelPartner(this.id, payload);
                    this.showSuccessMessage('Lead updated successfully!');
                }
                await vue.$parent.refreshData();
                this.open = false;
            } catch (e) {
                this.$vs.loading.close('#create-marketing-lead-popup > .con-vs-loading')
                this.convertAndNotifyError(e)
            }
            this.$vs.loading.close('#create-marketing-lead-popup > .con-vs-loading')
        },
    },
    components: {
        flatPickr,
        'v-select': vSelect,
    },
    computed: {
        ...mapGetters(['countries', 'staffs'])
    },
    mixins: [SuccessMessage, ErrorMessages],
}
</script>
  
<style scoped>
.add-new-incoterms>>>.vs-popup {
    /*min-height: 50% !important;*/
    min-width: 60% !important;
}
</style>
  